<template>
  <a-modal
    title="数据导出"
    :visible="visible"
    :mask-closable="false"
    :width="460"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <div class="a-import">
      <a-row :gutter="16">
        <a-col :span="8">
          <span>
            <a-radio-group
              :options="importOptions"
              default-value="1"
              @change="onChange($event)"
            /></span>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    importOptions: {
      type: Array,
      default: function () { return [{ label: '按年数据导出', value: '0' }, { label: '按月数据导出', value: '1' }] }
    }
  },

  data () {
    return {
      subRecord: false,
      isChange: false
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        this.subRecord = false
        this.isChange = false
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('cancel')
    },
    handleOk () {
      if (this.isChange) {
        this.$emit('exportOk', this.subRecord)
      } else {
        this.$emit('exportOk', 1)
      }
    },
    onChange (e) {
      this.isChange = true
      this.subRecord = Number(e.target.value)
    }
  }
}
</script>
<style lang="less" scoped>
.a-import {
  /deep/.ant-row {
    margin: 20px;
  }
}
</style>
